<template>
  <div class="home">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero__bg">
        <img src="@/assets/images/hero-bg.png" alt="" class="hero__bg-image" />
        <div class="hero__overlay"></div>
      </div>
      <div class="container">
        <div class="hero__content">
          <h1 class="hero__title">
            <span class="hero__title-line">Connect Legal Talents Everywhere.</span>
            <span class="hero__title-line hero__title-line--accent">Reach Legal Minds Across Border</span>
          </h1>
          <p class="hero__subtitle">
            Global Alliance of Emerging Legal Talents is dedicated to providing a dynamic platform <br /> for emerging legal talents worldwide to connect, collaborate, and grow together.&nbsp;<router-link to="/about" class="hero__more">more</router-link>
          </p>
          <!-- <div class="hero__actions">
            <router-link to="/member-directory" class="btn btn-accent-home btn-lg">
              Explore Network
            </router-link>
            <router-link to="/about" class="btn btn-outline-light btn-lg">
              Learn More
            </router-link>
          </div> -->
        </div>

        <div class="hero__stats">
          <div class="stat">
            <span class="stat__number">{{ animatedStats.jurisdictions }}</span>
            <span class="stat__label">Jurisdictions</span>
          </div>
          <div class="stat">
            <span class="stat__number">{{ animatedStats.firms }}</span>
            <span class="stat__label">Member Firms</span>
          </div>
          <div class="stat">
            <span class="stat__number">{{ animatedStats.lawyers }}</span>
            <span class="stat__label">Legal Talents</span>
          </div>
        </div>

        <div class="hero__actions">
            <router-link to="/member-directory" class="btn btn-accent-home btn-lg">
              Explore Network
            </router-link>
          </div>
        <!-- <div class="hero__scroll">
          <span>Scroll</span>
          <div class="scroll-indicator"></div>
        </div> -->
      </div>
    </section>

    <!-- About Section -->
    <section class="section about-section">
      <div class="container">
        <div class="about-grid">
          <div class="about-content">
            <!-- <span class="section-label">About Us</span> -->
            <h2>ABOUT US </h2>
            <div class="divider divider-left"></div>
            <p class="lead">
              Global Alliance of Emerging Legal Talents (“GELT”) is dedicated to providing a dynamic platform for emerging legal talents worldwide to connect, collaborate, and grow together. We warmly welcome legal talents under the age of 45 from across the globe — whether you are a lawyer, judge, in-house counsel, prosecutor or law student — to join us through a simple registration process.
            </p>
            <!-- <p>
Through the GELT platform, you can access potential professional networks in any region around the world. In addition, we regularly organize both online and offline events to facilitate the sharing of industry insights and explore collaborative opportunities.
            </p>
            <p>
              Our goal is to empower every member of the GELT community to efficiently gain industry experience, build extensive global connections, and support the rapid growth of the next generation of legal talents and minds.
            </p> -->
            <!-- <router-link to="/about" class="btn btn-primary">Discover Our Story</router-link> -->
          </div>
          <div class="about-visual">
            <img src="@/assets/images/global-network.png" alt="Global Network" class="about-image" />
          </div>
        </div>
      </div>
    </section>

    <!-- Why LAW Section -->
    <!-- <section class="section why-section">
      <div class="container">
        <div class="section-header">
          <span class="section-label">Why Choose LAW</span>
          <h2>Unparalleled <span class="text-gradient">Advantages</span></h2>
          <div class="divider"></div>
        </div>
        <div class="features-grid">
          <div class="feature-card" v-for="(feature, index) in whyFeatures" :key="index">
            <div class="feature-card__icon">
              <img :src="feature.icon" :alt="feature.title" />
            </div>
            <h4>{{ feature.title }}</h4>
            <p>{{ feature.description }}</p>
          </div>
        </div>
        <div class="text-center mt-4">
          <router-link to="/about/why-law" class="btn btn-secondary">Explore Benefits</router-link>
        </div>
      </div>
    </section> -->

    <!-- News Grid -->
    <!-- <section class="section news-section">
      <div class="container">
        <div class="news-grid">
          <div class="news-column">
            <h3 class="news-column__title">
              <span class="title-accent"></span>
              Upcoming Events
            </h3>
            <div class="event-list">
              <div v-for="event in events" :key="event.id" class="event-item">
                <div class="event-date">{{ event.date }}</div>
                <h5>{{ event.title }}</h5>
              </div>
            </div>
            <router-link to="/meetings" class="view-all-link">View All Events</router-link>
          </div>

          <div class="news-column">
            <h3 class="news-column__title">
              <span class="title-accent"></span>
              Latest News
            </h3>
            <div class="news-list">
              <router-link v-for="article in news" :key="article.id" :to="`/news/${article.slug}`" class="news-item">
                <h5>{{ article.title }}</h5>
              </router-link>
            </div>
            <router-link to="/news" class="view-all-link">View All News</router-link>
          </div>

          <div class="news-column">
            <h3 class="news-column__title">
              <span class="title-accent"></span>
              New Members
            </h3>
            <div class="members-list">
              <router-link v-for="member in newestMembers" :key="member.id" :to="`/firms/${member.slug}`" class="member-item">
                <h5>{{ member.name }}</h5>
                <span class="member-location">{{ member.location }}</span>
              </router-link>
            </div>
            <router-link to="/find-a-firm" class="view-all-link">View All Members</router-link>
          </div>
        </div>
      </div>
    </section> -->

    <!-- CTA Section -->
    <section class="section cta-section">
      <div class="container cta-flex-container">
        <div class="cta-content">
          <span class="cta-label">Join Our Network</span>
          <h2 class="cta-title">Elevate Your Practice</h2>
          <p class="cta-description">Join a growing network of emerging legal talents across multiple jurisdictions worldwide.</p>
          <div class="cta-buttons">
            <router-link to="/join-law/request-info" class="cta-btn-solid">Request Information</router-link>
            <router-link to="/contact" class="cta-btn-outline">contact us</router-link>
          </div>
        </div>
        <!-- <div class="cta-image-container">
          <img src="@/assets/images/cta-team.png" alt="Our Team" class="cta-team-image" />
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'

// Import SVG icons as data URLs
const iconLanguage = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23DCC19F'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129'/%3E%3C/svg%3E"
const iconGlobe = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23DCC19F'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A11.978 11.978 0 0112 16.5a11.978 11.978 0 01-8.716-3.747m0 0A8.959 8.959 0 013 12c0-1.052.18-2.062.512-3'/%3E%3C/svg%3E"
const iconBriefcase = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23DCC19F'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z'/%3E%3C/svg%3E"
const iconUsers = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23DCC19F'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z'/%3E%3C/svg%3E"
const iconChip = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23DCC19F'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6.75v10.5a2.25 2.25 0 002.25 2.25zm.75-12h9v9h-9v-9z'/%3E%3C/svg%3E"
const iconHeart = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23DCC19F'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z'/%3E%3C/svg%3E"

export default {
  name: 'HomeView',
  setup() {
    const animatedStats = reactive({
      jurisdictions: 0,
      firms: 0,
      lawyers: 0
    })
    
    // Current real numbers — bump these up over time as the network grows.
    const targetStats = {
      jurisdictions: 6,
      firms: 8,
      lawyers: 125
    }
    
    const whyFeatures = [
      { icon: iconLanguage, title: 'Multilingual Excellence', description: 'Fluency in all major languages ensuring seamless cross-border transactions.' },
      { icon: iconGlobe, title: 'Instant Global Access', description: 'One call connects you to trusted legal counsel in any jurisdiction.' },
      { icon: iconBriefcase, title: 'Business Opportunities', description: 'Leverage our network to unlock international business prospects.' },
      { icon: iconUsers, title: 'Local Expertise', description: 'Deep-rooted connections within each local legal community.' },
      { icon: iconChip, title: 'Cost Efficiency', description: 'Optimized service delivery with cutting-edge technology.' },
      { icon: iconHeart, title: 'Personalized Service', description: 'Direct partner access and relationship-driven approach.' }
    ]
    
    const events = [
      { id: 1, title: '2026 Americas Regional Meeting', date: 'APR' },
      { id: 2, title: 'Intellectual Property Summit', date: 'MAY' },
      { id: 3, title: 'European Employment Forum', date: 'JUN' }
    ]
    
    const news = [
      { id: 1, title: 'Member Firm Receives Global Recognition Award', slug: 'global-recognition' },
      { id: 2, title: 'LAW Partner Keynotes International Legal Conference', slug: 'international-conference' },
      { id: 3, title: 'New Practice Group for Emerging Technologies', slug: 'emerging-tech' }
    ]
    
    const newestMembers = [
      { id: 1, name: 'Sterling & Partners LLP', slug: 'sterling-partners', location: 'Sydney, Australia' },
      { id: 2, name: 'Meridian Legal Group', slug: 'meridian-legal', location: 'São Paulo, Brazil' },
      { id: 3, name: 'Nordic Law Alliance', slug: 'nordic-law', location: 'Stockholm, Sweden' }
    ]
    
    const animateNumber = (target, key, duration = 2000) => {
      const startTime = performance.now()
      
      const animate = (currentTime) => {
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / duration, 1)
        const easeOutQuart = 1 - Math.pow(1 - progress, 4)
        animatedStats[key] = Math.floor(easeOutQuart * target)
        
        if (progress < 1) {
          requestAnimationFrame(animate)
        }
      }
      
      requestAnimationFrame(animate)
    }
    
    onMounted(() => {
      setTimeout(() => {
        animateNumber(targetStats.jurisdictions, 'jurisdictions', 2000)
        animateNumber(targetStats.firms, 'firms', 2000)
        animateNumber(targetStats.lawyers, 'lawyers', 2500)
      }, 500)
    })
    
    return { animatedStats, whyFeatures, events, news, newestMembers }
  }
}
</script>

<style scoped>
.home {
  overflow-x: hidden;
  width: 100%;
  position: relative;
}

/* Hero Section */
.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  color: var(--white);
  overflow: hidden;
}

.hero__bg {
  position: absolute;
  inset: 0;
}

.hero__bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(1.1) contrast(1.05);
}

.hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(5, 8, 16, 0.3) 0%, rgba(10, 22, 40, 0.5) 100%);
}

.hero .container {
  position: relative;
  z-index: 1;
  text-align: left;
  padding-top: 0; /* Resetting padding to use specific margins */
}


.hero__content {
  max-width: 1360px; /* Matching container width */
  margin: 0;
}

.hero__title {
  margin-bottom: 2rem;
}

.hero__title-line {
  display: block;
  max-width: 100%;
  height: auto;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: clamp(32px, 8vw, 80px);
  font-family: inherit;
  font-weight: bold;
  text-align: left;
  line-height: 1.1;
  margin: 110px 0 0 0;
}

.hero__title-line--accent {
  max-width: 100%;
  height: auto;
  overflow-wrap: break-word;
  color: rgba(220, 193, 159, 1);
  font-size: clamp(32px, 8vw, 80px);
  font-family: inherit;
  font-weight: bold;
  text-align: left;
  line-height: 1.1;
  margin: 15px 0 0 0;
  background: none;
  -webkit-text-fill-color: initial;
}

.hero__subtitle {
  max-width: 1000px;
  width: 100%;
  height: auto;
  overflow-wrap: break-word;
  color: rgba(220, 193, 159, 1);
  font-size: clamp(16px, 2vw, 24px);
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: normal;
  text-align: left;
  line-height: 1.4;
  margin: 40px 0 60px 0;
}

.hero__more {
  font-family: PingFangSC, PingFang SC, sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: #DCC19F;
  line-height: 33px;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  display: inline;
}

.hero__actions {
  display: flex;
  gap: 1.5rem;
  justify-content: flex-start;
  flex-wrap: wrap;
  transform: translateY(-20px);
}

.hero__stats {
  display: flex;
  justify-content: flex-start;
  gap: clamp(2rem, 5vw, 8rem);
  margin-top: 5rem;
  flex-wrap: wrap;
  transform: translateY(-50px);
}

.stat {
  text-align: center;
}

.stat__number {
  display: block;
  font-family: "Toppan Bunkyu Midashi Mincho Extrabold", serif;
  font-size: 4rem;
  font-weight: 800; /* ExtraBold */
  color: #DCC19F;
  line-height: 1;
}

.stat__label {
  font-family: "PingFang SC", "苹方-简", sans-serif;
  font-size: 0.9rem;
  font-weight: 400; /* Regular */
  color: #DCC19F;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  margin-top: 0.75rem;
  display: block;
}

.hero__scroll {
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.75rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.scroll-indicator {
  width: 1px;
  height: 40px;
  background: linear-gradient(180deg, #DCC19F 0%, transparent 100%);
  animation: scrollPulse 2s ease infinite;
}

@keyframes scrollPulse {
  0%, 100% { opacity: 1; transform: scaleY(1); }
  50% { opacity: 0.5; transform: scaleY(0.8); }
}

/* About Section */
.about-section {
  background: var(--white);
}

.about-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
  align-items: center;
}

.section-label {
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: #DCC19F;
  margin-bottom: 1rem;
}

.about-content h2 {
  font-size: 2.75rem;
  margin-bottom: 0;
}

.divider {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #DCC19F, #bca17f);
  margin: 1.5rem 0;
}

.divider-left {
  margin-left: 0;
}

.lead {
  font-size: 1.15rem;
  color: var(--gray-600);
  line-height: 1.8;
}

.about-content p {
  color: var(--gray-500);
  line-height: 1.8;
}

.about-visual {
  position: relative;
}

.about-image {
  width: 100%;
  height: auto;
  border-radius: var(--radius-lg);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

/* Why Section */
.why-section {
  background: linear-gradient(180deg, #0a1628 0%, #050810 100%);
  color: var(--white);
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-header h2 {
  color: var(--white);
  font-size: 2.75rem;
  margin-bottom: 0;
}

.section-header .divider {
  margin: 1.5rem auto;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.feature-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 2.5rem;
  border-radius: var(--radius-lg);
  transition: all var(--transition-smooth);
}

.feature-card:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: var(--accent);
  transform: translateY(-5px);
}

.feature-card__icon {
  width: 48px;
  height: 48px;
  margin-bottom: 1.5rem;
}

.feature-card__icon img {
  width: 100%;
  height: 100%;
}

.feature-card h4 {
  color: var(--white);
  font-size: 1.2rem;
  margin-bottom: 0.75rem;
}

.feature-card p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.95rem;
  line-height: 1.7;
  margin: 0;
}

/* News Section */
.news-section {
  background: var(--gray-50);
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
}

.news-column__title {
  font-family: var(--font-display);
  font-size: 1.5rem;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.title-accent {
  width: 4px;
  height: 24px;
  background: linear-gradient(180deg, #DCC19F, #bca17f);
  border-radius: 2px;
}

.event-date {
  font-size: 0.8rem;
  font-weight: 600;
  color: #DCC19F;
  letter-spacing: 0.1em;
  margin-bottom: 0.25rem;
}

.event-item, .news-item, .member-item {
  padding: 1.25rem 0;
  border-bottom: 1px solid var(--gray-200);
  display: block;
  text-decoration: none;
  color: inherit;
  transition: all 0.2s ease;
}

.event-item h5, .news-item h5, .member-item h5 {
  font-family: var(--font-family);
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0;
  color: var(--gray-800);
}

.member-location {
  font-size: 0.85rem;
  color: var(--gray-500);
}

.news-item:hover h5, .member-item:hover h5 {
  color: var(--primary);
}

.view-all-link {
  display: inline-block;
  margin-top: 1.5rem;
  color: var(--primary);
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.02em;
}

/* CTA Section */
.cta-section {
  position: relative;
  background-color: #072A5B;
  background-image: url("@/assets/images/cta-background.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: var(--white);
  height: 328px; 
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0; 
  overflow: hidden;
}


.cta-flex-container {
  width: 100%;
  max-width: 1360px; /* Aligned with standard container width */
  margin: 0 auto;
  padding: 0 40px;
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 2;
}

.cta-content {
  position: relative;
  z-index: 5;
  max-width: 650px;
  padding: 20px 0;
  text-align: left;
}

.cta-label {
  display: block;
  color: rgba(220, 193, 159, 1);
  font-size: 20px;
  font-family: serif;
  font-weight: bold;
  margin-bottom: 16px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.cta-title {
  color: rgba(220, 193, 159, 1);
  font-size: clamp(28px, 4vw, 56px);
  font-family: serif;
  font-weight: bold;
  line-height: 1.1;
  margin: 0 0 20px 0;
}

.cta-description {
  color: rgba(220, 193, 159, 0.9);
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 32px;
  max-width: 500px;
}

.cta-buttons {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.cta-btn-solid, .cta-btn-outline {
  height: 48px;
  width: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.cta-btn-solid {
  background-color: #DCC19F;
  color: #072A5B;
}

.cta-btn-outline {
  border: 1px solid #DCC19F;
  color: #DCC19F;
}

.cta-btn-solid:hover {
  background-color: #EAD0B0;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.3);
}

.cta-btn-outline:hover {
  background-color: rgba(220, 193, 159, 0.1);
  transform: translateY(-2px);
}

.cta-image-container {
  position: absolute; /* Lock to section boundaries ignored of flex flow */
  right: 0;
  bottom: 0;
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  pointer-events: none; /* Let text be clickable if image overlaps */
  z-index: 1;
}

.cta-team-image {
  height: 105%; /* Subtle pop-out effect */
  width: auto;
  max-width: 100%;
  object-fit: contain;
  object-position: bottom right;
  display: block;
}

/* Responsive */
@media (max-width: 1200px) {
  .cta-flex-container {
    padding: 0 40px;
  }
}

@media (max-width: 992px) {
  .cta-section {
    height: auto;
    min-height: 500px;
    padding: 60px 0;
    background-position: center center;
  }
  .cta-flex-container {
    flex-direction: column;
    justify-content: center;
    padding: 0 20px;
    height: auto;
    gap: 0;
  }
  .cta-content {
    max-width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 40px;
    padding: 0;
  }
  .cta-label, .cta-title, .cta-description {
    text-align: center;
    width: 100%;
    white-space: normal;
  }
  .cta-buttons {
    justify-content: center;
    gap: 15px;
  }
  .cta-btn-solid, .cta-btn-outline {
    width: 100%;
    max-width: 280px;
  }
  .cta-image-container {
    position: relative;
    width: 100%;
    height: 300px;
    justify-content: center;
    margin-top: 20px;
  }
  .cta-team-image {
    height: 100%;
    width: auto;
    object-position: bottom center;
  }
  .hero__title { font-size: 3.5rem; }
  .hero__stats { gap: 3rem; }
  .stat__number { font-size: 3rem; }
  .about-grid { grid-template-columns: 1fr; }
  .features-grid, .news-grid { grid-template-columns: 1fr; }
}

@media (max-width: 576px) {
  .hero__title { font-size: 2.5rem; }
  .stat__number { font-size: 2.5rem; }
  .hero__stats { flex-direction: column; gap: 2rem; }
}

/* Home-specific accent button to avoid global/footer scope */
.btn-accent-home {
  background: #DCC19F;
  color: #ffffff;
  border: 1px solid #DCC19F;
  font-weight: 700;
}

.btn-accent-home:hover:not(:disabled) {
  background: #eee1d1;
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 0 40px rgba(220, 193, 159, 0.3);
  border-color: #eee1d1;
}

.btn-outline-yellow {
  background: transparent;
  color: #DCC19F;
  border: 2px solid #DCC19F !important;
}

.btn-outline-yellow:hover:not(:disabled) {
  background: rgba(220, 193, 159, 0.1);
  color: #eee1d1;
  border-color: #eee1d1 !important;
}

.text-gradient {
  background: linear-gradient(135deg, #eee1d1 0%, #DCC19F 50%, #bca17f 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
</style>
